import photo1 from './images/photo1.JPG'

export const tileData = [
    {
        img: photo1,
        title: 'Image',
        author: 'author',
        cols: 1,
    },
]